var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Add, CheckCircleRounded, ErrorRounded, PictureAsPdf } from '@mui/icons-material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Button, CircularProgress, ListItemText, Stack, Tab, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setInspectionSearchValue, setInspectionSortSelectedItem, setTemplateSearchValue } from 'app/actions/checklist';
import { FilterButton, IconButton, InputSearch, Scrollbar } from 'app/components';
import Table from 'app/components/Table';
import { FilterIcon } from 'app/icons';
import { ChecklistInspectionFilterDialog, ChecklistInspectionView, ChecklistTemplateDialog, ChecklistTemplateList, ChecklistTemplateView, } from 'app/pages/Checklist';
import { invokeObjectUrl, useAsyncAction, usePermission, useRoles } from 'app/services';
import { downloadDamageReport, downloadPdf, inspectionDetailLoad, inspectionExportLoad, inspectionLoad, templateLoad, } from 'app/store/checklist';
import { autocolunItemsLoad, divisionItemsLoad } from 'app/store/transport';
import ExcelJS from 'exceljs';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const ChecklistInspectionColumns = (column, data, pdfPermission) => {
    const downloadHandler = (inspection_id) => {
        return () => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield downloadPdf(inspection_id);
            const inspectionDate = new Date(data.created_at).toISOString().split('T')[0];
            const pdfName = `Акт осмотра ТС ${data.number}_${data.trailer}_${inspectionDate}.pdf`;
            const blob = new Blob([response.data], { type: 'application/pdf' });
            invokeObjectUrl(blob, pdfName);
        });
    };
    return (React.createElement(ListItemText, { key: column.name, sx: Object.assign({ width: column.width }, (column.name === 'status' && {
            justifyContent: 'center',
            '.MuiTypography-root': {
                display: 'flex',
            },
        })) },
        column.name === 'download' && (data.template_id == 27 || data.template_id == 62) && pdfPermission && (React.createElement(PictureAsPdf, { onClick: downloadHandler(data.id) })),
        column.name === 'status' ? (data.status ? (React.createElement(CheckCircleRounded, { fontSize: 'small', color: 'success' })) : (React.createElement(ErrorRounded, { fontSize: 'small', color: 'error' }))) : (React.createElement(Typography, null, column.format ? column.format(data[column.name]) : data[column.name]))));
};
const Checklist = () => {
    const dispatch = useDispatch();
    const editPermission = useRoles([config.userRoles['ADMIN_CHECKLIST']]);
    const pdfPermission = usePermission(['pdf']);
    const { inspectionItems, inspectionHasMore, inspectionSearchValue, inspectionSelectedFilters, inspectionSelectedFiltersLength, inspectionSortSelectedItem, inspectionSelectedItem, } = useSelector((state) => state.checklist);
    const { templateItems, templateSearchValue } = useSelector((state) => state.checklist);
    const [tab, setTab] = useState('inspection');
    const [fetchTab, setFetchTab] = useState([false, false]);
    const [anchorInspectorFilterEl, setAnchorInspectorFilterEl] = useState(null);
    const loadMoreOffsetRef = useRef(null);
    const { asyncAction: fetchInspectionData, isLoading: isFetchInspectionLoading } = useAsyncAction(inspectionLoad, [
        inspectionSearchValue,
        inspectionSelectedFilters,
        inspectionSortSelectedItem,
    ]);
    const { asyncAction: fetchMoreInspections, isLoading: isFetchMoreInspectionsLoading } = useAsyncAction(inspectionLoad);
    const { asyncAction: fetchInspectionDetail } = useAsyncAction(inspectionDetailLoad);
    const { asyncAction: fetchTemplateData, isLoading: isFetchTemplateLoading, isSuccessful: isFetchTemplateSuccessful, } = useAsyncAction(templateLoad);
    const { asyncAction: fetchAutocolonData, isSuccessful: isFetchAutocolonSuccessful } = useAsyncAction(autocolunItemsLoad);
    const { asyncAction: fetchDivisionData, isSuccessful: isFetchDivisionSuccessful } = useAsyncAction(divisionItemsLoad);
    const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
    const inspectionRequestParams = useMemo(() => (Object.assign(Object.assign({}, inspectionSelectedFilters), { limit: 50, search: inspectionSearchValue, sort: inspectionSortSelectedItem.name, order: inspectionSortSelectedItem.order })), [inspectionSearchValue, inspectionSelectedFilters, inspectionSortSelectedItem]);
    const handleInspectionSearchChange = (value) => dispatch(setInspectionSearchValue(value));
    const handleTemplateSearchChange = (value) => dispatch(setTemplateSearchValue(value));
    const handleInspectionSortChange = (value) => dispatch(setInspectionSortSelectedItem(value));
    const handleInspectionItemClick = (value) => fetchInspectionDetail(value);
    const handleDownloadClick = () => __awaiter(void 0, void 0, void 0, function* () {
        const inspectionItemsForExport = yield inspectionExportLoad(inspectionRequestParams);
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Inspections', {
            pageSetup: {
                orientation: 'landscape',
                paperSize: 9,
                fitToPage: true,
                fitToWidth: 1,
                fitToHeight: 0,
            },
        });
        const headerRow = worksheet.addRow([
            'Наименование марки, модели ТС',
            'Гос. номер ТС',
            'ФИО проверяющего',
            'Дата и время контроля',
            'Показания одометра',
            'Статус',
            'Подпись',
        ]);
        inspectionItemsForExport.forEach((item) => {
            var _a;
            const dataRow = worksheet.addRow([
                item.model_id || '',
                item.number || '',
                item.employee || '',
                moment(item.created_at).format('DD.MM.YYYY HH:mm'),
                ((_a = item.odometer) !== null && _a !== void 0 ? _a : '').toString(),
                item.status ? 'Пройден' : 'Не пройден',
                '',
            ]);
            dataRow.eachCell((cell) => {
                cell.alignment = {
                    wrapText: true,
                    vertical: 'top',
                    horizontal: 'left',
                };
            });
        });
        worksheet.columns = [
            {
                header: 'Наименование марки, модели ТС',
                key: 'model',
                width: 40,
            },
            { header: 'Гос. номер ТС', key: 'number', width: 20 },
            { header: 'ФИО проверяющего', key: 'employee', width: 30 },
            { header: 'Дата и время контроля', key: 'date', width: 25 },
            { header: 'Показания одометра', key: 'odometer', width: 20 },
            { header: 'Статус', key: 'status', width: 15 },
            { header: 'Подпись', key: 'signature', width: 25 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = {
                horizontal: 'center',
                vertical: 'middle',
                wrapText: true,
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFFFF' },
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });
        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber > 1) {
                row.eachCell((cell) => {
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' },
                    };
                });
            }
        });
        worksheet.eachRow((row) => {
            row.alignment = { wrapText: true };
        });
        const buffer = yield workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `inspections_${new Date().toISOString().slice(0, 10)}.xlsx`;
        link.click();
        setTimeout(() => {
            URL.revokeObjectURL(url);
        }, 100);
    });
    const handleDownloadDamageReport = () => {
        downloadDamageReport();
    };
    useEffect(() => {
        // Если пользователь пытается перейти на вкладку template без прав, перенаправляем на inspection
        if (tab === 'template' && !editPermission) {
            setTab('inspection');
            return;
        }
        if (tab === 'template') {
            setFetchTab(([inspectionTab]) => [inspectionTab, true]);
            if (!isFetchAutocolonSuccessful) {
                fetchAutocolonData();
            }
            if (!isFetchDivisionSuccessful) {
                fetchDivisionData();
            }
            if (!isFetchTemplateSuccessful) {
                fetchTemplateData();
            }
        }
    }, [tab, editPermission]);
    useEffect(() => {
        if (tab !== 'inspection') {
            return;
        }
        loadMoreOffsetRef.current = null;
        setFetchTab(([, templateTab]) => [true, templateTab]);
        const timeout = window.setTimeout(() => fetchInspectionData(Object.assign(Object.assign({}, inspectionRequestParams), { offset: 0, append: false })), inspectionSearchValue ? 300 : 0);
        return () => window.clearTimeout(timeout);
    }, [tab, inspectionRequestParams]);
    useEffect(() => {
        if (!isFetchMoreInspectionsLoading) {
            loadMoreOffsetRef.current = null;
        }
    }, [inspectionItems.length, isFetchMoreInspectionsLoading]);
    const handleLoadMoreInspections = () => {
        if (!inspectionHasMore || isFetchMoreInspectionsLoading || loadMoreOffsetRef.current === inspectionItems.length) {
            return;
        }
        loadMoreOffsetRef.current = inspectionItems.length;
        fetchMoreInspections(Object.assign(Object.assign({}, inspectionRequestParams), { offset: inspectionItems.length, append: true }));
    };
    return (React.createElement(Stack, { direction: 'row', sx: {
            width: '100%',
            height: '100%',
            overflow: 'hidden',
        } },
        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                width: '660px',
                height: '100%',
                zIndex: '1010',
                overflow: 'hidden',
                bgcolor: 'background.paper',
                transition: 'transform 300ms',
                boxShadow: '0px 1px 3px ' + alpha(theme.palette.grey.main, 0.12),
            }) },
            React.createElement(TabContext, { value: tab },
                React.createElement(Stack, { direction: 'row', sx: (theme) => ({
                        width: '100%',
                        position: 'relative',
                        '.MuiTabs-root': {
                            width: '100%',
                            minHeight: '44px',
                        },
                        '.MuiTabs-flexContainer': Object.assign({ borderColor: theme.palette.divider, bgcolor: 'background.default' }, (tab !== 'transport' && {
                            borderColor: 'transparent',
                        })),
                        '.MuiTab-root': {
                            minHeight: '44px',
                            fontSize: '12px',
                            flex: '1 1 0px',
                            '&.Mui-selected': {
                                color: 'inherit',
                                bgcolor: 'background.paper',
                            },
                            '&.Mui-selected:not(.Mui-selected)': {
                                color: theme.palette.text.secondary,
                            },
                        },
                    }) },
                    React.createElement(TabList, { variant: 'fullWidth', onChange: (event, value) => setTab(value) },
                        React.createElement(Tab, { value: 'inspection', label: '\u041E\u0441\u043C\u043E\u0442\u0440\u044B', disableRipple: true }),
                        editPermission && React.createElement(Tab, { value: 'template', label: '\u0428\u0430\u0431\u043B\u043E\u043D\u044B', disableRipple: true }))),
                React.createElement(Stack, { direction: 'row', sx: (theme) => ({
                        flex: '1 1 auto',
                        display: 'flex',
                        overflow: 'hidden',
                        '.MuiTabPanel-root': {
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            padding: theme.spacing(0),
                        },
                        '.MuiTabPanel-root[hidden]': {
                            display: 'none',
                        },
                    }) },
                    React.createElement(TabPanel, { value: 'inspection', sx: { position: 'relative' } },
                        !isFetchInspectionLoading && fetchTab[0] && inspectionItems.length !== 0 && (React.createElement(React.Fragment, null,
                            React.createElement(Stack, { direction: 'row', alignItems: 'center', sx: (theme) => ({
                                    padding: theme.spacing(1),
                                    '.MuiInputBase-root': {
                                        padding: '6px 8px',
                                        marginRight: theme.spacing(1),
                                    },
                                    '.MuiButton-endIcon > svg': {
                                        fontSize: '16px',
                                        svg: {
                                            paddingLeft: '2px',
                                        },
                                    },
                                }) },
                                React.createElement(InputSearch, { placeholder: '\u0413\u043E\u0441\u043D\u043E\u043C\u0435\u0440 \u0438\u043B\u0438 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A', value: inspectionSearchValue, onChange: handleInspectionSearchChange }),
                                React.createElement(FilterButton, Object.assign({}, {
                                    label: 'Фильтры',
                                    badgeContent: inspectionSelectedFiltersLength,
                                    ref: anchorInspectorFilterEl,
                                }, { active: !!anchorInspectorFilterEl, onClick: (event) => setAnchorInspectorFilterEl(event.currentTarget), endIcon: React.createElement(FilterIcon, { width: 16, height: 16 }) })),
                                React.createElement(Button, { variant: 'contained', disableElevation: true, onClick: handleDownloadClick, sx: (theme) => ({
                                        position: 'relative',
                                        minWidth: 'auto',
                                        color: theme.palette.text.secondary,
                                        padding: '6px 10px',
                                        height: '100%',
                                        bgcolor: 'background.default',
                                        borderWidth: '0',
                                        borderStyle: 'solid',
                                        borderColor: theme.palette.divider,
                                        textTransform: 'initial',
                                        gap: '4px',
                                        marginLeft: '6px',
                                        span: {
                                            margin: theme.spacing(0),
                                        },
                                        path: {
                                            fill: theme.palette.text.secondary,
                                        },
                                        '&:hover, &.active': {
                                            bgcolor: 'background.default',
                                        },
                                        '&.Mui-disabled': {
                                            bgcolor: alpha(theme.palette.text.secondary, 0.05),
                                        },
                                    }) }, "\u0421\u043A\u0430\u0447\u0430\u0442\u044C"),
                                React.createElement(Button, { variant: 'contained', disableElevation: true, onClick: handleDownloadDamageReport, sx: (theme) => ({
                                        position: 'relative',
                                        minWidth: 'auto',
                                        color: theme.palette.text.secondary,
                                        padding: '6px 10px',
                                        height: '100%',
                                        bgcolor: 'background.default',
                                        borderWidth: '0',
                                        borderStyle: 'solid',
                                        borderColor: theme.palette.divider,
                                        textTransform: 'initial',
                                        gap: '4px',
                                        marginLeft: '6px',
                                        span: {
                                            margin: theme.spacing(0),
                                        },
                                        '& .MuiSvgIcon-root': {
                                            fill: theme.palette.text.secondary,
                                        },
                                        '&:hover, &.active': {
                                            bgcolor: 'background.default',
                                            '& .MuiSvgIcon-root': {
                                                fill: theme.palette.text.secondary,
                                            },
                                        },
                                        '&.Mui-disabled': {
                                            bgcolor: alpha(theme.palette.text.secondary, 0.05),
                                        },
                                    }), startIcon: React.createElement(AssessmentIcon, null) }),
                                React.createElement(ChecklistInspectionFilterDialog, { open: !!anchorInspectorFilterEl, onClose: () => setAnchorInspectorFilterEl(null) })),
                            React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                                    height: '100%',
                                    overflow: 'hidden',
                                } },
                                React.createElement(Table, { columns: config.inspectionColumns, customColumnsRender: (column, data) => ChecklistInspectionColumns(column, data, pdfPermission), showColumns: config.inspectionColumns.map((column) => column.name), rows: inspectionItems, selectedRow: inspectionSelectedItem, searchValue: '', storageColumnsWidthKey: 'inspectionTable', sortSelectedKey: inspectionSortSelectedItem, manualSort: true, hasMore: inspectionHasMore, isLoadingMore: isFetchMoreInspectionsLoading, onLoadMore: handleLoadMoreInspections, onRowClick: (row) => handleInspectionItemClick(row), onSortChange: handleInspectionSortChange })))),
                        !isFetchInspectionLoading && fetchTab[0] && inspectionItems.length === 0 && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                                width: '100%',
                                height: '100%',
                                padding: theme.spacing(2),
                            }) },
                            React.createElement(Typography, { align: 'center', variant: 'body1', component: 'span' }, "\u0417\u0434\u0435\u0441\u044C \u043F\u043E\u043A\u0430 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435\u0442"),
                            React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'span' }, "\u0412 \u044D\u0442\u043E\u043C \u0440\u0430\u0437\u0434\u0435\u043B\u0435 \u0431\u0443\u0434\u0435\u0442 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u044C\u0441\u044F \u0441\u043F\u0438\u0441\u043E\u043A \u043E\u0441\u043C\u043E\u0442\u0440\u043E\u0432"))),
                        (isFetchInspectionLoading || !fetchTab[0]) && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                                width: '100%',
                                height: '100%',
                                padding: theme.spacing(2),
                            }) },
                            React.createElement(CircularProgress, { size: 24 })))),
                    editPermission && (React.createElement(TabPanel, { value: 'template' },
                        !isFetchTemplateLoading && fetchTab[1] && templateItems.length !== 0 && (React.createElement(React.Fragment, null,
                            React.createElement(Stack, { direction: 'row', alignItems: 'center', sx: (theme) => ({
                                    padding: theme.spacing(1),
                                    '.MuiInputBase-root': {
                                        padding: '6px 8px',
                                    },
                                    '.MuiButton-endIcon > svg': {
                                        fontSize: '16px',
                                        svg: {
                                            paddingLeft: '2px',
                                        },
                                    },
                                }) },
                                React.createElement(InputSearch, { placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435', value: templateSearchValue, onChange: handleTemplateSearchChange }),
                                React.createElement(IconButton, { onClick: () => setTemplateDialogOpen(true), endIcon: React.createElement(Add, null) }),
                                React.createElement(ChecklistTemplateDialog, { open: templateDialogOpen, onClose: () => setTemplateDialogOpen(false) })),
                            React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                                    height: '100%',
                                    overflow: 'hidden',
                                } },
                                React.createElement(ChecklistTemplateList, null)))),
                        !isFetchTemplateLoading && fetchTab[1] && templateItems.length === 0 && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                                width: '100%',
                                height: '100%',
                                padding: theme.spacing(2),
                            }) },
                            React.createElement(Typography, { align: 'center', variant: 'body1', component: 'span' }, "\u0417\u0434\u0435\u0441\u044C \u043F\u043E\u043A\u0430 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435\u0442"),
                            React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'span' }, "\u0412 \u044D\u0442\u043E\u043C \u0440\u0430\u0437\u0434\u0435\u043B\u0435 \u0431\u0443\u0434\u0435\u0442 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u044C\u0441\u044F \u0441\u043F\u0438\u0441\u043E\u043A \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432 \u0434\u043B\u044F \u043E\u0441\u043C\u043E\u0442\u0440\u043E\u0432"))),
                        (isFetchTemplateLoading || !fetchTab[1]) && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                                width: '100%',
                                height: '100%',
                                padding: theme.spacing(2),
                            }) },
                            React.createElement(CircularProgress, { size: 24 })))))))),
        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                height: '100%',
                flex: '1 1 auto',
                bgcolor: theme.palette.background.default,
                '.simplebar-content': {
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                },
                '.MuiTabPanel-root': {
                    width: '100%',
                    height: '100%',
                    padding: 0,
                },
            }) },
            React.createElement(Scrollbar, null,
                React.createElement(TabContext, { value: tab },
                    React.createElement(TabPanel, { value: 'inspection' },
                        React.createElement(ChecklistInspectionView, null)),
                    editPermission && (React.createElement(TabPanel, { value: 'template' },
                        React.createElement(ChecklistTemplateView, null))))))));
};
export default Checklist;
